import {Injectable} from '@angular/core';
import {NavigationEnd} from '@angular/router';
import {environment} from '../../environments/environment';
import {User} from '../model/auth/User';

// tslint:disable-next-line:ban-types
declare let gtag: Function;

export enum EventType {
  sign_up = 'sign_up',
  login = 'login',
  begin_checkout = 'begin_checkout',

  purchase = 'purchase',
  purchase_failed = 'purchase_failed',
  remove_from_cart = 'remove_from_cart',

  view_item = 'view_item',

  contest_create = 'contest_create',
  contest_update = 'contest_update',

  user_invited = 'user_invited',

  contest_task_saved = 'contest_task_saved',
  contest_localization_removed = 'contest_localization_removed',

  contest_exam_started = 'contest_exam_started',
  contest_exam_restored = 'contest_exam_restored',
  contest_exam_finished = 'contest_exam_finished',
  contest_exam_timed_up = 'contest_exam_timed_up',
  contest_exam_answered = 'contest_exam_answered',

  contest_exam_client_time_shift = 'contest_exam_client_time_shift',
}

export enum EventCategory {
  contest = 'contest',
  contest_exam = 'contest_exam',
  engagement = 'engagement',
  purchase = 'purchase',
}

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  public configureAnalytics(): void {
    gtag('config', environment.track.analyticsId);
  }

  public trackPageView(event: NavigationEnd): void {
    gtag('config', environment.track.analyticsId,
      {
        page_path: event.urlAfterRedirects
      }
    );
  }

  public trackUser(user?: User): void {
    if (user) {
      gtag('config', environment.track.analyticsId, {
        'user_id': user.id
      });
    }
  }

  public sendEvent(action: EventType, category?: string, label?: string, value?: number): void {
    const data: { [key: string]: string | number } = {};
    if (category) data['event_category'] = category;
    if (label) data['event_label'] = label;
    if (value != undefined) data['value'] = value;

    if (action == EventType.purchase) {
      data['currency'] = 'UAH';
    }

    gtag('event', action, data);
  }
}
